import { useState } from "react";
import { Globe, X } from "lucide-react";
import { LANG, LANGS, setLang, suggestedLang, dismissLangSuggest, langPath, stripLang } from "@/lib/i18n";

export function LangSwitcher({ className = "" }) {
  return (
    <label className={`inline-flex items-center gap-1 rounded-full border border-white/15 px-2 py-1 text-xs text-slate-300 ${className}`} data-no-translate title="Dil / Language">
      <Globe className="h-3.5 w-3.5 text-slate-400" />
      <select value={LANG} onChange={(e) => setLang(e.target.value)} data-testid="lang-switcher" className="bg-transparent outline-none">
        {Object.entries(LANGS).map(([k, l]) => <option key={k} value={k} className="bg-[#0D111A]">{l}</option>)}
      </select>
    </label>
  );
}

const MSG = { en: ["This page is also available in English.", "Switch to English"], de: ["Diese Seite gibt es auch auf Deutsch.", "Auf Deutsch anzeigen"], fr: ["Cette page est aussi disponible en français.", "Afficher en français"], tr: ["Bu sayfa Türkçe olarak da mevcut.", "Türkçe göster"] };

export function LangSuggestBar() {
  const [sug, setSug] = useState(suggestedLang);
  if (!sug) return null;
  const [msg, btn] = MSG[sug];
  const href = langPath(stripLang(window.location.pathname), sug) + window.location.search;
  return (
    <div data-no-translate className="flex items-center justify-center gap-3 border-b border-emerald-500/20 bg-emerald-500/10 px-4 py-2 text-xs text-emerald-100 sm:text-sm" data-testid="lang-suggest-bar">
      <Globe className="hidden h-4 w-4 text-emerald-300 sm:block" />
      <span>{msg}</span>
      <a href={href} onClick={() => localStorage.setItem("fa-lang", sug)} className="rounded-full bg-emerald-400 px-3 py-1 font-semibold text-[#0A0D14] hover:bg-emerald-300" data-testid="lang-suggest-switch">{btn}</a>
      <button type="button" onClick={() => { dismissLangSuggest(); setSug(null); }} className="rounded-full p-1 text-emerald-200/70 hover:bg-white/10" aria-label="Close" data-testid="lang-suggest-dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
}
